(function()
{
	'use strict';
	
	app
		.service('lodashService', lodashService);
	
	lodashService.$inject = ['$window'];

		function lodashService($window) {
			/**
			 * https://stackoverflow.com/questions/23862119/how-to-make-lodash-work-with-angular-js#25086064
			 */
			return $window._;
		}
})();